<app-button buttonType="text" icon="chevron-left" (clickit)="goBack()">
	Terug naar
	@if (bestuur()) {
		Bestuur
	} @else if (account()) {
		Gebruikers
	} @else {
		Instellingen
	}
</app-button>

@if (instelling$ | async; as instelling) {
	<div class="header">
		<h2>{{ instelling.naam }}</h2>
		<app-instelling-labels [instelling]="instelling"></app-instelling-labels>
		@if (instelling.backupName) {
			<div class="detail">{{ instelling.backupName }}</div>
		}
		@if (instelling.databaseName) {
			<div class="detail">{{ instelling.databaseName }}</div>
		}
		@if (instelling.database) {
			<div class="detail">{{ instelling.database }}</div>
		}
		@if (instelling.schema) {
			<div class="detail">{{ instelling.schema }}</div>
		}
		@if (instelling.uuid) {
			<div class="detail">{{ instelling.uuid }}</div>
		}
		<div class="right buttons">
			@if (instelling.actief) {
				@if (instelling.bron === InstellingBron.Magister) {
					<app-button buttonType="text" icon="settings" (clickit)="magisterSettings()">Instellingen</app-button>
				}
				<app-button buttonType="secondary" (clickit)="deactivateInstelling(instelling)">Instelling deactiveren</app-button>
			} @else {
				<app-button buttonType="secondary" (clickit)="deleteInstelling(instelling)">Instelling verwijderen</app-button>
				<app-button buttonType="primary" (clickit)="activateInstelling(instelling)">Instelling activeren</app-button>
			}
		</div>
	</div>

	<div class="cards">
		<div class="row">
			<div class="column">
				<div class="card login">
					<h3>Inloggen als</h3>
					<app-single-select-dropdown
						[opties]="activeAccountOptions()"
						[selectedOptie]="selectedAccountOption()"
						(onOptieClicked)="selectedAccount.set($event); accountZoekFilter.set('')"
						[showSearchInput]="true"
						[searchInput]="accountZoekFilter()"
						(onSearchInput)="accountZoekFilter.set($event)"
						[enabled]="instelling.actief! && accountOptions().length > 0"
					>
					</app-single-select-dropdown>
					<app-button
						(clickitCtrl)="impersonate(selectedAccount()!, '_self')"
						(clickit)="impersonate(selectedAccount()!, '_blank')"
						[enabled]="selectedAccount() !== undefined"
						[ctrlClickEnabled]="true"
					>
						Inloggen
					</app-button>
				</div>
				<div class="card data">
					<h3>Dataverwerking</h3>
					@if (!instelling.actief) {
						<div>
							<span>Instelling is gedeactiveerd. Er vindt geen dataverwerking plaats.</span>
						</div>
					} @else if (instelling.etlUitgeschakeld === 1) {
						<div>
							<span>Dataverwerking is uitgeschakeld. Er vindt geen dataverwerking plaats.</span>
						</div>
					} @else if (!instelling.instellingETLStatus) {
						<div>
							<span>Er heeft nog geen dataverwerking plaatsgevonden.</span>
						</div>
					} @else {
						<div
							class="etl"
							[class.etl-bezig]="etlBezigStatussen.includes(instelling.instellingETLStatus)"
							[class.etl-failed]="instelling.instellingETLStatus === InstellingETLStatus.GEFAALD"
							[class.etl-succesvol]="instelling.instellingETLStatus === InstellingETLStatus.GESLAAGD"
						>
							<app-icon
								[name]="ETL_ICON[instelling.instellingETLStatus]!.name"
								[color]="ETL_ICON[instelling.instellingETLStatus]!.color"
							></app-icon>
							<div class="message">
								<span>{{ instelling.laatsteRun | date: format }}</span>
								@switch (instelling.instellingETLStatus) {
									@case (InstellingETLStatus.GEPLAND) {
										<span>Nieuwe ETL verwerking gepland.</span>
									}
									@case (InstellingETLStatus.BEZIG) {
										<span>Nieuwe ETL verwerking bezig.</span>
										<span>Laatst succesvolle verwerking: {{ instelling.laatsteSuccesvolleRun | date: format }}</span>
									}
									@case (InstellingETLStatus.GEFAALD) {
										<span>Dataverwerking mislukt.</span>
										@if (isDefaultStartDatum(instelling.laatsteSuccesvolleRun!)) {
											<span>Er heeft nog geen eerdere succesvolle verwerking plaatsgevonden.</span>
										} @else {
											<span>Laatst succesvolle verwerking: {{ instelling.laatsteSuccesvolleRun | date: format }}</span>
										}
									}
									@case (InstellingETLStatus.GESLAAGD) {
										<span>Dataverwerking succesvol.</span>
									}
								}
							</div>
						</div>
					}
					@if (instelling.actief) {
						@if (instelling.etlUitgeschakeld === 0) {
							<app-button buttonType="secondary" (clickit)="deactivateDataverwerking(instelling)">
								Dataverwerking deactiveren
							</app-button>
						} @else {
							<app-button buttonType="primary" (clickit)="activateDataverwerking(instelling)"> Dataverwerking activeren </app-button>
						}
					}
				</div>
				<div class="card handmatige-verwerking">
					<h3>Handmatige verwerking</h3>
					<app-button
						buttonType="primary"
						[fullWidth]="true"
						[enabled]="handmatigeDeltaVerwerkingBeschikbaar()"
						(clickit)="startDeltaverwerking(instelling)"
					>
						@if (instelling.nextETLBulk) {
							Start bulkverwerking nu
						} @else {
							Start deltaverwerking nu
						}
					</app-button>
					<app-button
						buttonType="secondary"
						[fullWidth]="true"
						[enabled]="handmatigeBulkVerwerkingBeschikbaar()"
						(clickit)="toggleBulkVerwerking(instelling)"
					>
						@if (instelling.nextETLBulk) {
							Annuleer bulkverwerking
						} @else {
							Plan bulkverwerking
						}
					</app-button>
				</div>
			</div>
			<div class="column">
				<div class="row wrap">
					<app-licenties-card [instelling]="instelling" (instellingChanged)="refreshInstelling$.next()"></app-licenties-card>
					<app-modules-card [instelling]="instelling" (instellingChanged)="refreshInstelling$.next()"></app-modules-card>
					<div class="card etl-runs">
						<div class="etl-card-header">
							<h3>Laatste runs</h3>
							<app-toggle-buttons
								[options]="options"
								[value]="selectedOption()"
								(valueChange)="selectedOption.set($event)"
							></app-toggle-buttons>
						</div>
						<table>
							<thead>
								<tr>
									<th>Datum</th>
									<th>Doorlooptijd</th>
									<th>Status</th>
									<th>Gefaalde stap</th>
								</tr>
							</thead>
							<tbody>
								@for (jobrunInstelling of jobruns(); track jobrunInstelling.id) {
									<tr
										[class.bezig]="jobrunInstelling.instellingETLStatus === InstellingETLStatus.BEZIG"
										(click)="openDetailsDialog(jobrunInstelling)"
									>
										<td>{{ jobrunInstelling.vanaf | date: "d-M-yyyy 'om' H:mm" }}</td>
										<td class="duration">
											{{ doorlooptijd(jobrunInstelling.vanaf, jobrunInstelling.totMet) }}
										</td>
										<td>{{ jobrunInstelling.instellingETLStatus }}</td>
										<td>{{ jobrunInstelling.stapGefaald }}</td>
									</tr>
								}
								<tr class="gemiddelde">
									<td>Gemiddeld</td>
									<td class="duration">{{ avgDoorlooptijd() }}</td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
}

<ng-template #confirmInstellingDeactiveren let-data>
	<app-confirm-dialog caption="School deactiveren" [singleAction]="data.bron === InstellingBron.Somtoday">
		@if (data.bron === InstellingBron.Magister) {
			Je staat op het punt om <b>{{ data.naam }}</b> te deactiveren. Gebruikers van deze instelling zullen dan geen toegang meer hebben tot
			CumLaude. Weet je dit zeker?
		} @else {
			Het deactiveren van <b>{{ data.naam }}</b> kan door met het support account in te loggen in de
			<a [href]="somtodayUrl">desbetreffende Somtoday omgeving</a>. Zet in Somtoday beheer de feature CumLaude uit om de school te deactiveren.
		}
	</app-confirm-dialog>
</ng-template>

<ng-template #confirmInstellingHeractiveren let-data>
	<app-confirm-dialog caption="School activeren" [singleAction]="data.bron === InstellingBron.Somtoday">
		@if (data.bron === InstellingBron.Magister) {
			Je staat op het punt om <b>{{ data.naam }}</b> te heractiveren. Alle gebruikers van deze instelling hebben dan weer toegang tot CumLaude.
			Weet je het zeker?
		} @else {
			Het heractiveren van <b>{{ data.naam }}</b> kan door met het support account in te loggen in de
			<a [href]="somtodayUrl">desbetreffende Somtoday omgeving</a>. Zet in Somtoday beheer de feature CumLaude aan om de school te heractiveren.
		}
	</app-confirm-dialog>
</ng-template>

<ng-template #confirmInstellingVerwijderen let-data>
	<app-confirm-dialog caption="School activeren">
		Je staat op het punt om <b>{{ data.naam }}</b> te verwijderen. Alle data en accounts van deze instelling zullen permanent worden verwijderd
		uit CumLaude. Weet je het zeker?
	</app-confirm-dialog>
</ng-template>

<ng-template #confirmInstellingBulkEnDelta>
	<app-confirm-dialog caption="Bulkverwerking staat aan">
		Je staat op het punt om per direct een bulkverwerking voor deze school te starten. Dit betekent dat de school enkele uren geen data zal zien.
		Weet je zeker dat je wilt doorgaan?
	</app-confirm-dialog>
</ng-template>
